import Table from '@eduzz/houston-ui/Table';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { InitialPagination } from 'v2/services/financialStatement/statement';

import type { SomeFinancialStatementTabs, IFinancialEntry } from 'v2/interfaces/financial';

import ContentItem from './ContentItem';
import useStyles from './styles';

import type IPagination from 'interfaces/IPagination';

interface IProps {
  id: string;
  data: IFinancialEntry[];
  pagination: IPagination;
  loading: boolean;
  handlePagination: {
    onChangeRowsPerPage: (per_page: number) => void;
    onChangePage: (page: number) => void;
  };
  balanceLabel: string;
  showBlockedDetails?: boolean;
  currentTab?: SomeFinancialStatementTabs;
}

function ContentTable({ id, data, pagination, loading, handlePagination, balanceLabel, showBlockedDetails, currentTab }: IProps) {
  const classes = useStyles();

  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleChangeCollapse = useCallback((newIndex: number) => setSelectedIndex((prevIndex) => (newIndex !== prevIndex ? newIndex : null)), []);

  useEffect(() => {
    if (!loading && data) {
      return setSelectedIndex(0);
    }
  }, [data, loading]);

  return (
    <Table id={id} total={pagination?.total_items || 0} loading={loading}>
      <Table.Body>
        {/* TODO analisar empty state */}
        {data?.map((entry: IFinancialEntry, index: number) => (
          <ContentItem
            selected={index === selectedIndex}
            handleSelect={handleChangeCollapse}
            data={entry}
            index={index}
            key={`ContentItem-${entry.transaction_date}`}
            balanceLabel={balanceLabel}
            showBlockedDetails={showBlockedDetails}
            currentTab={currentTab}
          />
        ))}
      </Table.Body>

      {!loading && (pagination?.total_pages > 1 || pagination?.per_page > InitialPagination.per_page) && (
        <Table.Pagination
          className={classes.paginationSelect}
          page={pagination?.current_page}
          perPage={pagination?.per_page}
          onChangePage={handlePagination.onChangePage}
          onChangePerPage={handlePagination.onChangeRowsPerPage}
          optionsPerPage='15,30,50,100,200'
        />
      )}
    </Table>
  );
}

export default memo(ContentTable);
